import React, { useMemo } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { TTrackTypes, TAgeFilter } from "../../../types";

interface IProps {
  handleClosePopup: () => void;
  isPopupShowing: boolean;
  ageFilter: TAgeFilter;
  track: TTrackTypes;
  numberOfSeats: number;
  numberOfRaces: number;
}

const NoRacesPopup: React.FC<IProps> = ({ handleClosePopup, isPopupShowing, ageFilter, track, numberOfSeats, numberOfRaces }) => {
  const determineNoRacesTitle = useMemo(() => {
    return <h2 className="tw-text-white tw-text-[24px] tw-font-bold tw-mb-[20px]">No Sessions Available for this Date</h2>;
  }, []);

  const determineNoRacesDescription = useMemo(() => {
    if (track === "JUNIOR_TRACK") {
      return (
        <>
          <p>There are currently no races available for Junior Track on this date. </p>
          <p>
            <br />
            Our Junior Track is open Friday - Sunday during school term and Monday - Sunday during school holidays. Change to one of these days to find availability.
          </p>
        </>
      );
    } else if (ageFilter === "Under 12") {
      return (
        <>
          <p>
            There are currently no under 12 races available for this date. Check out our{" "}
            <a className="tw-text-[#9d62fe]" href={`https://hyperkarting.com.au/pages/junior-track?numberOfSeats=${numberOfSeats}&numberOfRaces=${numberOfRaces}&homepage=false`}>
              Junior Track
            </a>{" "}
            instead (only available for racers 120cm+)
          </p>
        </>
      );
    } else {
      return (
        <>
          <p>There are currently no races available for this date and experience. Try a different date or check out another experience</p>
        </>
      );
    }
  }, [track, ageFilter, numberOfSeats, numberOfRaces]);
  return (
    <>
      {isPopupShowing && (
        <div className="tw-fixed tw-z-[1000] tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50" onClick={(e) => e.stopPropagation()}>
          <div className="tw-mx-[20px] lg:tw-mx-0">
            <div className="tw-bg-[#393B41] lg:tw-max-w-[998px] tw-w-full tw-mx-auto tw-rounded-[15px] tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100">
              <div className="tw-py-[10px] tw-px-[10px]">
                <div className="tw-flex tw-justify-end">
                  <button
                    className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClosePopup();
                    }}
                  >
                    <AiOutlineClose className="tw-w-[30px] tw-h-[30px] tw-text-white tw-font-[400]" />
                  </button>
                </div>
                <div className="tw-flex tw-justify-center tw-items-center">
                  <div className="tw-text-white tw-text-left tw-p-0 lg:tw-pb-[30px] lg:tw-px-[80px]">
                    <div className="tw-text-white tw-text-[24px] tw-font-bold tw-mb-[20px]">{determineNoRacesTitle}</div>
                    <div className="tw-text-white tw-text-[16px]">{determineNoRacesDescription}</div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClosePopup();
                      }}
                      className="tw-mt-[30px] tw-mb-[30px] lg:tw-mb-0 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-w-fit tw-h-[57px] tw-overflow-hidden tw-py-[16px] tw-px-[40px] tw-font-bold tw-text-[18px] tw-rounded-[100px] tw-text-white tw-bg-[linear-gradient(71deg,#a852ff_28.13%,#7886ff)]"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NoRacesPopup;
